// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__B4b2o","author":"Table_author__34Rqy","authorImage":"Table_authorImage__10E1l","unreadRow":"Table_unreadRow__-kpR_"};